<template>
  <div id="login">
    <div class="loginConbox">
      <div class="header"></div>
      <div class="loginBox">
        <div class="loginCon">
          <p class="title"></p>
          <el-card class="login-module">
            <div slot="header" class="clearfix formTitlt">
              <span>修改系统配置</span>
            </div>
            <el-form :model="configForm" class="demo-ruleForm">
              <el-row :gutter="12">
                <el-col :span="24" style="display: none;">
                  <el-form-item label="序号" prop="id">
                    <el-input v-model="configForm.id"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="汇聚云平台地址" prop="huijuCloudAPIUrl">
                    <el-input v-model="configForm.huijuCloudAPIUrl" placeholder="请输入平台地址"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="是否启用" prop="huijuCloudAPIUrl_enable">
                    <el-select v-model="configForm.huijuCloudAPIUrl_enable" style="width:100%">
                      <el-option
                        v-for="item in type_options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button class="subBtn" type="primary" @click="submitForm">确认提交</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      configForm: {
        id: "",
        huijuCloudAPIUrl: "",
        huijuCloudAPIUrl_enable: ""
      },
      type_options: [
        {
          value: 0,
          label: "是"
        },
        {
          value: 1,
          label: "否"
        }
      ]
    };
  },
  methods: {
    submitForm() {
      let huijuCloudAPIUrl = this.configForm.huijuCloudAPIUrl;
      let huijuCloudAPIUrl_enable = this.configForm.huijuCloudAPIUrl_enable;
      let id = this.configForm.id;
      console.log(huijuCloudAPIUrl_enable);
      if (huijuCloudAPIUrl == "") {
        this.$message({
          showClose: true,
          message: "请输入正确的指向地址",
          type: "error",
          duration: 5000
        });
        return;
      }
      // 添加数据
      this.$axios({
        url: "/api/sysConfig/edit",
        method: "post",
        data: {
          id: id,
          huijuCloudAPIUrl: huijuCloudAPIUrl,
          huijuCloudAPIUrl_enable: huijuCloudAPIUrl_enable
        },
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      })
        .then(res => {
          if ((res.data = true)) {
            this.$message({
              showClose: true,
              message: "success,添加信息成功",
              type: "success",
              duration: 5000
            });
            this.message(); //重新获取数据
          } else {
            this.$message({
              showClose: true,
              message: "error,添加信息失败",
              type: "error",
              duration: 5000
            });
            this.message(); //重新获取数据
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: "error,添加信息失败",
            type: "error",
            duration: 5000
          });

          this.message(); //重置表单数据
        });
    },
    message() {
      this.$axios({
        url: "/api/sysConfig",
        method: "get",
        data: {},
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      })
        .then(res => {
          this.configForm.id = res.data[0][0].id;
          this.configForm.huijuCloudAPIUrl = res.data[0][0].huijuCloudAPIUrl;
          this.configForm.huijuCloudAPIUrl_enable =
            res.data[0][0].huijuCloudAPIUrl_enable;
        })
        .catch(err => {
          console.log(err);
          this.$message({
            showClose: true,
            message: "error,获取信息失败",
            type: "error",
            duration: 5000
          });
        });
    }
  },
  mounted() {
    this.message();
  }
};
</script>
<style lang="scss">
#login {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  .loginConbox {
    background: #ffffff;
  }
  .header {
    height: 40px;
    position: relative;
    background: #ffffff;
    /*border-bottom: 1px solid rgba(255, 255, 255, 0.3);*/
    .logo {
      margin-left: 30px;
      width: 500px;
      float: left;
      height: 40px;
      padding-top: 10px;
      img {
        height: 100%;
      }
    }
  }
  .demo-ruleForm {
    margin-top: -30px;
  }
  .loginBox {
    .iconcolor {
      color: #409eff;
    }
    padding: 74px 0 118px;
    .loginCon {
      width: 100%;
      height: 100%;
      margin: auto;
      position: relative;
      .el-card__header {
        border-bottom: 0px;
      }
      .title {
        font-size: 34px;
        font-weight: 600;
        color: #ffffff;
        width: 500px;
        margin-left: 40%;
        &:first-child {
          font-size: 34px;
          margin-top: 100px;
          margin-bottom: 0px;
        }
      }
      .login-module {
        width: 380px;
        margin-top: 10px;
        border: none;
        margin-left: 40%;
        .formTitlt {
          font-size: 18px;
          font-weight: 400;
          .titIconbox {
            float: right;
            .pointer {
              cursor: pointer;
            }
          }
        }
        .smalltxt {
          text-align: right;
          .a {
            text-decoration: none;
            color: #999999;
            font-size: 12px;
            margin-left: 8px;
          }
        }
      }
      .el-form-item__content {
        margin-left: 0px !important;
        .subBtn {
          width: 100%;
        }
      }
    }
    .el-input__inner,
    .el-button,
    .el-card,
    .el-message {
      border-radius: 0px !important;
    }
    .el-form-item__content .ico {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 999;
      width: 40px;
      height: 39px;
      text-align: center;
      border-right: 1px solid #ccc;
    }
    .ewmbox {
      width: 100%;
      height: 240px;
      margin-top: -25px;
      .ewm {
        width: 140px;
        height: 140px;
        margin: 20px auto;
        p {
          font-size: 12px;
          padding-left: 40px;
          margin: 0;
        }
      }
      .ewmicon {
        width: 140px;
        margin: 20px auto 0;
        .iconfont {
          float: left;
        }
        p {
          font-size: 12px;
          padding-left: 40px;
          margin: 0;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/system/index/config/config.vue